/**
 * Изоляция пользовательского текста по направлению письма.
 *
 * Названия продуктов, профилей, ботов и имена покупателей бывают на иврите,
 * часто вперемешку с латиницей («השתתפות בכנס AI לעסקים»). Вставленный в
 * русскую строку или в поле с направлением слева направо, такой текст
 * показывается с переставленными словами. В JSX такие вставки оборачивают в
 * <bdi>; там, где разметки нет (confirm(), title, placeholder, <option> с
 * припиской), — в невидимые символы FSI…PDI (U+2068…U+2069): браузер
 * определяет направление куска по первой сильной букве, остальной текст не
 * трогает. В данные, которые уходят на сервер, эти символы не добавлять.
 */
export function isolate(text: string): string {
  return `⁨${text}⁩`;
}
